__turbopack_context__.v({
  "blockAnchorProductList": "BlockAnchorProductList-module-scss-module__mB-6aa__blockAnchorProductList",
  "copy": "BlockAnchorProductList-module-scss-module__mB-6aa__copy",
  "heading3": "BlockAnchorProductList-module-scss-module__mB-6aa__heading3",
  "heading3Alt": "BlockAnchorProductList-module-scss-module__mB-6aa__heading3Alt",
  "heading4": "BlockAnchorProductList-module-scss-module__mB-6aa__heading4",
  "headline": "BlockAnchorProductList-module-scss-module__mB-6aa__headline",
  "introLockup": "BlockAnchorProductList-module-scss-module__mB-6aa__introLockup",
  "paragraph": "BlockAnchorProductList-module-scss-module__mB-6aa__paragraph",
  "richText": "BlockAnchorProductList-module-scss-module__mB-6aa__richText",
  "textLockup": "BlockAnchorProductList-module-scss-module__mB-6aa__textLockup",
});
